import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeSharedModule } from '../../../../shared/font-awesome/font-awesome';
import { DELETE_ORGANIZATION_WARNING_MODAL_ID } from '../../constants/organization-constants';
import { DialogService } from '../../../../shared/services/dialog.service';

@Component({
  selector: 'app-delete-organization-warning-modal',
  standalone: true,
  imports: [CommonModule, FontAwesomeSharedModule],
  templateUrl: './delete-organization-warning-modal.component.html',
})
export class DeleteOrganizationWarningModalComponent {
  private dialogService = inject(DialogService);
  modalId = DELETE_ORGANIZATION_WARNING_MODAL_ID;
  @Input() organizationName: string = '';

  closeModal() {
    this.dialogService.close(DELETE_ORGANIZATION_WARNING_MODAL_ID);
  }

  onBackdropClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.id === this.modalId) {
      this.closeModal();
    }
  }
}

